import React, { useState } from 'react';
import { useImmer } from 'use-immer';
import XLSX from 'xlsx';
import { useFormik } from 'formik';
import * as Yup from "yup";
import { Card, Form, Jumbotron, Col, Button } from 'react-bootstrap';
import DropdownMultiselect from 'react-multiselect-dropdown-bootstrap';
import FormControls from '../../controls/formControls';
import { AdminMetricsService, CustomerAccountService } from '../../services';
import { TabList, TabItem } from '../../controls';
import { useEffect } from 'react';
import ReportParametersContainer from '../../controls/report/ReportParametersContainer';
import CustomerSelector from '../../controls/report/selectors/CustomerSelector';
import DateSelector from '../../controls/report/selectors/DateSelector';
import { LinkContainer } from 'react-router-bootstrap';

const monthPrevious = (last = false) => {
    var d = new Date();
    d.setDate(0);
    if (!last) {
        d.setDate(1);
    }
    return d;
}

const AdminReports = () => {
    return (
        <Card className="h-80">
            <Card.Header className="d-flex align-items-center">
                <div className="mr-auto" >Assessment Metrics</div>
                <div className="card-btn-group">
                </div>
            </Card.Header>
            <Card.Body>
                <LinkContainer to={'/admin/reports/assessment/qa'}>
                    <a>Assessment QA Report</a>
                </LinkContainer><br/><br/>
                <LinkContainer to={'/admin/reports/assessment/raw'}>
                    <a>Assessment QA Report (Raw Data)</a>
                </LinkContainer>
            </Card.Body>
        </Card>
    )
}

export default AdminReports;